import req from './req'

// 会员关系-获取社群列表
export function customerBaseGetList (params) {
  return req.get('/salesperson/customer-base/get-list', params)
}

// 客户-客户详情
export function getCustomerDetail (params) {
  return req.get(`/members/member-detail/${params.memberId}`)
}

// 客户-客户相关导购
export function getGuideByCustomer (params) {
  return req.get(`/members/member-salesperson/${params.memberId}`)
}

// 客户-常购清单
export function getBuyGoodsList (params) {
  return req.get(`/members/member-goods`, params).then((res) => {
    console.log('客户-常购清单', res)
    res.list = res.list.map((d) => {
      d.price = d.price / 100 + '元'
      return d
    })
    return res
  })
}

// 客户-客户订单
export function getMemberOrder (params) {
  return req.get(`/members/member-order`, params).then((res) => {
    console.log('客户-客户订单', res)
    res.avg_amount = res.avg_amount / 100 + '元'
    res.total_amount = res.total_amount / 100
    res.list = res.list.map((d) => {
      d.total_fee = d.total_fee / 100 + '元'
      d.items = d.items.map((dd) => {
        dd.item_fee = dd.item_fee / 100 + '元'
        dd.price = dd.price / 100 + '元'
        return dd
      })
      return d
    })
    return res
  })
}

// 客户-足迹
export function getFootPrint (params) {
  return req.get(`/members/member-footprint`, params).then((res) => {
    console.log('客户-足迹', res)
    res.list = res.list.map((d) => {
      d.itemData.price = d.itemData.price / 100 + '元'
      return d
    })
    return res
  })
}

// 客户-导出
export function memberExport (params) {
  return req.post('/members/member-export', params)
}

// 客户-今日统计
export function todayStatistics (params) {
  return req.get('/members/member-todaystat', params)
}

// 客户-客户统计
export function customerStatistics (params) {
  return req.get('/members/member-statistics', params)
}

// 客户-统计导出
export function statisticsExport (params) {
  return req.get('/members/member-statistics-export', params)
}

// 客户-渠道列表
export function getChannelList (params) {
  return req.get('/members/channel-list', params)
}

//
// 获取导购员列表
export function getSalesmanList (params) {
  return req.get('/salesperson/salesperson', params)
}
// 导购接口-批量更新导购身份
export function changeSpecialIdentity (params) {
  return req.post('/salesperson/special-identity/update', params)
}

// 绑定导购员门店信息
export function saveBindStore (params) {
  return req.post('/salesperson/save-bind-store', params)
}

// 导购接口-导购绑定群组
export function saveBindGroup (params) {
  return req.post('/salesperson/save-bind-group', params)
}
